// extracted by mini-css-extract-plugin
export default {"textareaItem":"Textarea_textareaItem__HOHt8"};